/**
 * Passe-partout Builder — Atelier Toon
 * Vanilla JS, geen frameworks
 */

(function () {
  'use strict';

  // ----------------------------------------------------------------
  // Config
  // ----------------------------------------------------------------

  const FORMATS = [
    { key: '21x30', label: 'A4 / 21×29,7 cm', w: 21, h: 29.7, option: 'A4/21x29.7 cm' },
    { key: '30x40', label: '30×40 cm', w: 30, h: 40, option: '30×40 cm' },
    { key: '40x50', label: '40×50 cm', w: 40, h: 50, option: '40×50 cm' },
    { key: '50x70', label: '50×70 cm', w: 50, h: 70, option: '50×70 cm' },
  ];

  const PRICES = {
    'small': { standaard: 20.95, linnenstof: 22.95 }, // onder 15×15 cm
    '21x30': { standaard: 25.95, linnenstof: 27.95 },
    '30x40': { standaard: 33.95, linnenstof: 35.95 },
    '40x50': { standaard: 43.95, linnenstof: 45.95 },
    '50x70': { standaard: 53.95, linnenstof: 55.95 },
  };

  const COLORS = [
    { name: 'Breezy Blue',       hex: '#C3DBF4', light: true  },
    { name: 'Hold My Olive',     hex: '#9E9440', light: false },
    { name: 'White Like A Wave', hex: '#F4F4F1', light: true  },
    { name: 'Bravo Blue',        hex: '#2E5491', light: false },
    { name: 'Canvas Cream',      hex: '#f5f2ea', light: true  },
    { name: 'Linnen 1',           hex: '#cfcec4', light: true,  texture: 'linen' },
    { name: 'Rioja Red',         hex: '#6E1A26', light: false },
    { name: 'Bold & Brown',      hex: '#5B2B1E', light: false },
    { name: 'Linnen 2',          hex: '#e8e0c7', light: true,  texture: 'linen' },
    { name: 'Butter Yellow',     hex: '#faefc2', light: true,  surcharge: 2 },
  ];

  // ----------------------------------------------------------------
  // i18n — locale-aware strings
  // ----------------------------------------------------------------

  const isEN = (window.ppbLocale || 'nl').startsWith('en');

  const T = {
    // Validation errors
    widthBetween:    isEN ? 'Width must be between 10 and 50 cm'      : 'Breedte moet tussen 10 en 50 cm zijn',
    heightBetween:   isEN ? 'Height must be between 10 and 70 cm'     : 'Hoogte moet tussen 10 en 70 cm zijn',
    enterValidSize:  isEN ? 'enter a valid inner size'                 : 'voer een geldige binnenmaat in',
    widthMin:        isEN ? 'width minimum {n} cm'                    : 'breedte minimaal {n} cm',
    heightMin:       isEN ? 'height minimum {n} cm'                   : 'hoogte minimaal {n} cm',
    widthMax:        isEN ? 'width too large (max {n} cm)'            : 'breedte te groot (max {n} cm)',
    heightMax:       isEN ? 'height too large (max {n} cm)'           : 'hoogte te groot (max {n} cm)',
    tooCloseBorder:  isEN ? 'Opening {n}: too close to the outer edge (min. {m} cm)' : 'Opening {n}: te dicht bij de buitenrand (min. {m} cm)',
    wouldOverlap:    isEN ? 'Opening {a} and {b} would overlap'       : 'Opening {a} en {b} zouden overlappen',
    tooClose:        isEN ? 'Opening {a} and {b} are too close together (min. 1 cm gap)' : 'Opening {a} en {b} zitten te dicht bij elkaar (min. 1 cm tussenruimte)',
    // Summary table
    labelFormat:     isEN ? 'Size'      : 'Formaat',
    labelMaterial:   isEN ? 'Material'  : 'Materiaal',
    labelColour:     isEN ? 'Colour'    : 'Kleur',
    labelOpenings:   isEN ? 'Openings'  : 'Openingen',
    labelInnerSize:  isEN ? 'Inner size': 'Binnenmaat',
    labelOpening:    isEN ? 'Opening'   : 'Opening',
    labelRotation:   isEN ? 'Rotation'  : 'Rotatie',
    // Materials
    matLinen:        isEN ? 'Linen'     : 'Linnenstof',
    matStandard:     isEN ? 'Standard'  : 'Standaard',
    // Per-opening inputs
    labelWidth:      isEN ? 'Width'     : 'Breedte',
    labelHeight:     isEN ? 'Height'    : 'Hoogte',
    labelLeft:       isEN ? 'Left'      : 'Links',
    labelRight:      isEN ? 'Right'     : 'Rechts',
    labelTop:        isEN ? 'Top'       : 'Boven',
    labelBottom:     isEN ? 'Bottom'    : 'Onder',
    labelSelect:     isEN ? 'Select'    : 'Selecteer',
    labelRotate:     isEN ? 'Rotation:' : 'Rotatie:',
    labelCentre:     isEN ? 'Centre:'   : 'Centreren:',
    cheatsheetBtn:   isEN ? 'View standard sizes' : 'Bekijk standaard maten',
    // Photo upload
    photoLoaded:     isEN ? 'Photo loaded'         : 'Foto geladen',
    photoRemove:     isEN ? 'Remove photo'         : 'Foto verwijderen',
    photoUpload:     isEN ? 'Upload photo (optional)' : 'Foto uploaden (optioneel)',
    // Cart
    adding:          isEN ? 'Adding…'         : 'Toevoegen…',
    addToCart:       isEN ? 'Add to cart'          : 'Toevoegen aan winkelwagen',
    addedToCart:     isEN ? 'Added to cart!'       : 'Toegevoegd aan winkelwagen!',
    productNotFound: isEN ? 'Product not found. Please contact hello@ateliertoon.com' : 'Product niet gevonden. Neem contact op via hello@ateliertoon.com',
    addError:        isEN ? 'Error adding to cart: ' : 'Fout bij toevoegen: ',
    // Align errors
    alignFailed:     isEN ? 'Alignment not possible: ' : 'Uitlijnen niet mogelijk: ',
    centreFailed:    isEN ? 'Centering not possible: ' : 'Centreren niet mogelijk: ',
    // Price label
    basedOn:         isEN ? ' (based on {label})' : ' (o.b.v. {label})',
    // SVG aria
    svgAria:         isEN ? 'Preview passe-partout {label}, {mat}, colour {col}' : 'Preview passe-partout {label}, {mat}, kleur {col}',
    // Overlap warning (dynamic text built in JS)
    openingPrefix:   isEN ? 'Opening '  : 'Opening ',
    // Cart property labels (visible in cart/order)
    cartColour:       isEN ? 'Colour'       : 'Kleur',
    cartOpenings:     isEN ? 'Openings'     : 'Aantal openingen',
    cartInnerSize:    isEN ? 'Inner size'   : 'Binnenmaat',
    cartMarginLeft:   isEN ? 'Left margin'  : 'Marge Links',
    cartMarginRight:  isEN ? 'Right margin' : 'Marge Rechts',
    cartMarginTop:    isEN ? 'Top margin'   : 'Marge Boven',
    cartMarginBottom: isEN ? 'Bottom margin': 'Marge Onder',
    cartPreview:      isEN ? '_Preview'      : '_Voorbeeld',
  };

  const MIN_MARGIN   = 2; // cm vrije ruimte tussen opening en buitenrand
  const MIN_GAP      = 1; // cm minimale tussenruimte (validatie)
  const LAYOUT_GAP   = 3; // cm tussenruimte bij initiële plaatsing
  const MIN_OPENING  = 3; // cm minimale breedte én hoogte van een opening

  // ----------------------------------------------------------------
  // State
  // ----------------------------------------------------------------

  let svgDrag   = null; // actieve drag/resize operatie op de SVG preview
  let snapLines = []; // { axis: 'v'|'h', pos: number (SVG-pixels) } tijdens verslepen

  const state = {
    // Stap 1 — Formaat
    format: '21x30',
    customFormat: false,
    customW: 21,
    customH: 30,

    // Stap 2 — Kleur + Materiaal
    material: 'standaard',
    color: COLORS[4].name, // Canvas Cream

    // Stap 3 — Binnenmaat (template / startwaarde voor nieuwe openingen)
    openingW: 7,
    openingH: 10,

    // Stap 4 — Openingen: elke opening heeft eigen afmeting, positie en foto
    openings: 1,
    openingPositions: Array.from({ length: 20 }, function () {
      return { left: null, top: null, w: 7, h: 10, rotation: 0, photoDataUrl: null, photoW: null, photoH: null };
    }),

    // Uitlijning — geselecteerde openingen (indices)
    selectedOpenings: new Set(),
  };

  // ----------------------------------------------------------------
  // Undo
  // ----------------------------------------------------------------

  const MAX_HISTORY = 30;
  const history = [];

  function saveHistory() {
    history.push({
      openings: state.openings,
      openingPositions: state.openingPositions.map(function (p) { return Object.assign({}, p); }),
      selectedOpenings: new Set(state.selectedOpenings),
    });
    if (history.length > MAX_HISTORY) history.shift();
    const btn = document.getElementById('ppb-undo');
    if (btn) btn.disabled = false;
  }

  function undoHistory() {
    if (!history.length) return;
    const snap = history.pop();
    state.openings = snap.openings;
    state.openingPositions = snap.openingPositions;
    state.selectedOpenings = snap.selectedOpenings; // selectie behouden
    const btn = document.getElementById('ppb-undo');
    if (btn) btn.disabled = history.length === 0;
    // Sync knoppen
    document.querySelectorAll('.ppb-opening-btn').forEach(function (b) {
      b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false');
    });
    const fixedBtn = document.getElementById('ppb-openings-' + state.openings);
    if (fixedBtn) { fixedBtn.classList.add('is-active'); fixedBtn.setAttribute('aria-pressed', 'true'); }
    const customInput = document.getElementById('ppb-openings-custom');
    if (customInput) customInput.value = [1,2,3,4].includes(state.openings) ? '' : state.openings;
    renderPositionInputs();
    update();
  }

  // ----------------------------------------------------------------
  // Helpers
  // ----------------------------------------------------------------

  function formatPrice(amount) {
    return '€\u00a0' + amount.toFixed(2).replace('.', ',');
  }

  function getActiveFormat() {
    if (state.customFormat) {
      return {
        key: 'custom',
        label: state.customW + '\u00d7' + state.customH + ' cm',
        w: state.customW,
        h: state.customH,
        option: 'custom',
      };
    }
    return FORMATS.find(f => f.key === state.format);
  }

  function getActiveColor() {
    return COLORS.find(c => c.name === state.color);
  }

  function getCustomFormatBaseKey() {
    const shorter = Math.min(state.customW, state.customH);
    const longer  = Math.max(state.customW, state.customH);
    if (shorter < 20 && longer < 25)           return 'small';  // onder 20×25 cm
    if (shorter <= 21 && longer <= 30)         return '21x30';  // t/m 21×30
    if (shorter <= 32 && longer <= 42)         return '30x40';  // t/m 32×42
    if (shorter <= 42 && longer <= 52)         return '40x50';  // t/m 42×52
    return '50x70';                                             // t/m 50×70
  }

  function getPrice() {
    const key = state.customFormat ? getCustomFormatBaseKey() : state.format;
    const base = PRICES[key][state.material];
    const color = COLORS.find(function (c) { return c.name === state.color; });
    const surcharge = (color && color.surcharge) ? color.surcharge : 0;
    return base + surcharge;
  }

  // ----------------------------------------------------------------
  // Validatie
  // ----------------------------------------------------------------

  function validateFormat() {
    if (!state.customFormat) return [];
    const errors = [];
    if (state.customW < 10 || state.customW > 50)
      errors.push(T.widthBetween);
    if (state.customH < 10 || state.customH > 70)
      errors.push(T.heightBetween);
    return errors;
  }

  function validateOpeningSize() {
    const fmt = getActiveFormat();
    const maxW = fmt.w - 2 * MIN_MARGIN;
    const maxH = fmt.h - 2 * MIN_MARGIN;
    const errors = [];
    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const prefix = state.openings > 1 ? 'Opening ' + (i + 1) + ': ' : '';
      if (od.w <= 0 || od.h <= 0)
        errors.push(prefix + T.enterValidSize);
      else if (od.w < MIN_OPENING)
        errors.push(prefix + T.widthMin.replace('{n}', MIN_OPENING));
      else if (od.h < MIN_OPENING)
        errors.push(prefix + T.heightMin.replace('{n}', MIN_OPENING));
      else if (od.w > maxW)
        errors.push(prefix + T.widthMax.replace('{n}', maxW.toFixed(1)));
      else if (od.h > maxH)
        errors.push(prefix + T.heightMax.replace('{n}', maxH.toFixed(1)));
    }
    return errors;
  }

  var FLOAT_EPSILON = 0.05; // tolerantie voor afrondingsfouten bij exact MIN_GAP

  function rectsTooClose(a, b) {
    return !(a.x + a.w + MIN_GAP - FLOAT_EPSILON <= b.x || b.x + b.w + MIN_GAP - FLOAT_EPSILON <= a.x ||
             a.y + a.h + MIN_GAP - FLOAT_EPSILON <= b.y || b.y + b.h + MIN_GAP - FLOAT_EPSILON <= a.y);
  }

  function rectsOverlap(a, b) {
    return !(a.x + a.w <= b.x || b.x + b.w <= a.x ||
             a.y + a.h <= b.y || b.y + b.h <= a.y);
  }

  function validatePositions() {
    const fmt = getActiveFormat();
    const errors = [];
    const rects = [];

    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const left = od.left !== null ? od.left : (fmt.w - od.w) / 2;
      const top  = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;

      if (left < MIN_MARGIN || left + od.w > fmt.w - MIN_MARGIN)
        errors.push(T.tooCloseBorder.replace('{n}', i + 1).replace('{m}', MIN_MARGIN));
      if (top < MIN_MARGIN || top + od.h > fmt.h - MIN_MARGIN)
        errors.push(T.tooCloseBorder.replace('{n}', i + 1).replace('{m}', MIN_MARGIN));

      rects.push({ x: left, y: top, w: od.w, h: od.h });
    }

    for (let i = 0; i < rects.length; i++) {
      for (let j = i + 1; j < rects.length; j++) {
        if (rectsTooClose(rects[i], rects[j])) {
          const msg = rectsOverlap(rects[i], rects[j])
            ? T.wouldOverlap.replace('{a}', i + 1).replace('{b}', j + 1)
            : T.tooClose.replace('{a}', i + 1).replace('{b}', j + 1);
          errors.push(msg);
        }
      }
    }

    return errors;
  }

  function validateAll() {
    return [...validateFormat(), ...validateOpeningSize(), ...validatePositions()];
  }

  // ----------------------------------------------------------------
  // Uitlijning van geselecteerde openingen
  // ----------------------------------------------------------------

  function alignOpenings(direction) {
    const indices = Array.from(state.selectedOpenings);
    if (indices.length < 2) return;
    if (['left', 'right', 'top', 'bottom'].indexOf(direction) === -1) return;
    saveHistory();

    // Sla huidige posities op zodat we kunnen terugdraaien bij validatiefout
    const snapshots = indices.map(function (i) {
      return { i: i, left: state.openingPositions[i].left, top: state.openingPositions[i].top };
    });

    if (direction === 'left') {
      const avg = parseFloat((indices.reduce(function (sum, i) { return sum + getEffectiveLeft(i); }, 0) / indices.length).toFixed(2));
      indices.forEach(function (i) { state.openingPositions[i].left = avg; });

    } else if (direction === 'right') {
      const avg = parseFloat((indices.reduce(function (sum, i) {
        return sum + getEffectiveLeft(i) + state.openingPositions[i].w;
      }, 0) / indices.length).toFixed(2));
      indices.forEach(function (i) {
        state.openingPositions[i].left = parseFloat((avg - state.openingPositions[i].w).toFixed(2));
      });

    } else if (direction === 'top') {
      const avg = parseFloat((indices.reduce(function (sum, i) { return sum + getEffectiveTop(i); }, 0) / indices.length).toFixed(2));
      indices.forEach(function (i) { state.openingPositions[i].top = avg; });

    } else if (direction === 'bottom') {
      const avg = parseFloat((indices.reduce(function (sum, i) {
        return sum + getEffectiveTop(i) + state.openingPositions[i].h;
      }, 0) / indices.length).toFixed(2));
      indices.forEach(function (i) {
        state.openingPositions[i].top = parseFloat((avg - state.openingPositions[i].h).toFixed(2));
      });
    }

    // Valideer resultaat; draai terug bij fout
    var errors = validatePositions();
    if (errors.length > 0) {
      snapshots.forEach(function (s) {
        state.openingPositions[s.i].left = s.left;
        state.openingPositions[s.i].top  = s.top;
      });
      var alignErr = document.getElementById('ppb-align-error');
      if (alignErr) {
        alignErr.textContent = T.alignFailed + errors[0].toLowerCase();
        alignErr.style.display = '';
        clearTimeout(alignErr._timer);
        alignErr._timer = setTimeout(function () {
          alignErr.style.display = 'none';
          alignErr.textContent = '';
        }, 5000);
      }
      return;
    }

    var alignErr = document.getElementById('ppb-align-error');
    if (alignErr) { alignErr.style.display = 'none'; alignErr.textContent = ''; }

    renderPositionInputs();
    update();
  }

  // ----------------------------------------------------------------
  // SVG Preview
  // ----------------------------------------------------------------

  function getOpeningRects(fmt, scale) {
    return Array.from({ length: state.openings }, (_, i) => {
      const od = state.openingPositions[i];
      const left = od.left !== null ? od.left : (fmt.w - od.w) / 2;
      const top  = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;
      return {
        x: left * scale,
        y: top  * scale,
        w: od.w  * scale,
        h: od.h  * scale,
        rot: od.rotation || 0,
        photoDataUrl: od.photoDataUrl,
        photoW:       od.photoW,
        photoH:       od.photoH,
      };
    });
  }

  function getTexturePattern(color, material, patternId) {
    const hex = color.hex;
    const isLinen = color.texture === 'linen' || material === 'linnenstof';
    if (isLinen) {
      // Realistisch geweven linnen-patroon: ketting (horizontaal) en inslag (verticaal)
      return '<pattern id="' + patternId + '" patternUnits="userSpaceOnUse" width="8" height="8">' +
        '<rect width="8" height="8" fill="' + hex + '"/>' +
        // Horizontale kettingdraden
        '<rect x="0" y="0" width="8" height="1.2" fill="rgba(255,255,255,0.13)"/>' +
        '<rect x="0" y="2" width="8" height="1.0" fill="rgba(0,0,0,0.07)"/>' +
        '<rect x="0" y="4" width="8" height="1.2" fill="rgba(255,255,255,0.10)"/>' +
        '<rect x="0" y="6" width="8" height="1.0" fill="rgba(0,0,0,0.06)"/>' +
        // Verticale inslagdraden
        '<rect x="0" y="0" width="1.2" height="8" fill="rgba(0,0,0,0.06)"/>' +
        '<rect x="2" y="0" width="1.0" height="8" fill="rgba(255,255,255,0.10)"/>' +
        '<rect x="4" y="0" width="1.2" height="8" fill="rgba(0,0,0,0.05)"/>' +
        '<rect x="6" y="0" width="1.0" height="8" fill="rgba(255,255,255,0.09)"/>' +
        // Kruispunt-highlights: afwisselend donker/licht voor weefsellook
        '<rect x="0" y="0" width="1.2" height="1.2" fill="rgba(0,0,0,0.09)"/>' +
        '<rect x="2" y="2" width="1.0" height="1.0" fill="rgba(0,0,0,0.08)"/>' +
        '<rect x="4" y="4" width="1.2" height="1.2" fill="rgba(0,0,0,0.09)"/>' +
        '<rect x="6" y="6" width="1.0" height="1.0" fill="rgba(0,0,0,0.08)"/>' +
        '<rect x="4" y="0" width="1.2" height="1.2" fill="rgba(255,255,255,0.14)"/>' +
        '<rect x="0" y="4" width="1.2" height="1.2" fill="rgba(255,255,255,0.12)"/>' +
        '<rect x="6" y="2" width="1.0" height="1.0" fill="rgba(255,255,255,0.11)"/>' +
        '<rect x="2" y="6" width="1.0" height="1.0" fill="rgba(255,255,255,0.11)"/>' +
        '</pattern>';
    } else {
      return '<pattern id="' + patternId + '" patternUnits="userSpaceOnUse" width="5" height="5">' +
        '<rect width="5" height="5" fill="' + hex + '"/>' +
        '<circle cx="1" cy="1.5" r="0.4" fill="rgba(0,0,0,0.04)"/>' +
        '<circle cx="3.5" cy="3.5" r="0.3" fill="rgba(0,0,0,0.03)"/>' +
        '<circle cx="2" cy="4" r="0.35" fill="rgba(255,255,255,0.06)"/>' +
        '<circle cx="4" cy="1" r="0.3" fill="rgba(255,255,255,0.05)"/>' +
        '</pattern>';
    }
  }

  function renderSVG() {
    const fmt = getActiveFormat();
    const color = getActiveColor();

    const maxW = 340;
    const maxH = 420;
    const scale = Math.min(maxW / fmt.w, maxH / fmt.h);

    const svgW = Math.round(fmt.w * scale);
    const svgH = Math.round(fmt.h * scale);

    const sizeErrors = [...validateFormat(), ...validateOpeningSize()];
    const hasSizeErrors = sizeErrors.length > 0;
    const openingRects = hasSizeErrors ? [] : getOpeningRects(fmt, scale);

    // Bepaal welke openingen te dicht bij elkaar staan (in pixel-coördinaten)
    const minGapPx = (MIN_GAP - FLOAT_EPSILON) * scale;
    const overlappingIndices = new Set();
    for (let i = 0; i < openingRects.length; i++) {
      for (let j = i + 1; j < openingRects.length; j++) {
        const a = openingRects[i], b = openingRects[j];
        if (!(a.x + a.w + minGapPx <= b.x || b.x + b.w + minGapPx <= a.x ||
              a.y + a.h + minGapPx <= b.y || b.y + b.h + minGapPx <= a.y)) {
          overlappingIndices.add(i);
          overlappingIndices.add(j);
        }
      }
    }

    const bgColor = '#d8d4cf';
    const patternId = 'ppb-tex';

    const texturePattern = getTexturePattern(color, state.material, patternId);

    const shadowFilter =
      '<filter id="ppb-shadow" x="-8%" y="-8%" width="116%" height="116%">' +
      '<feDropShadow dx="0" dy="3" stdDeviation="5" flood-color="rgba(0,0,0,0.18)"/>' +
      '</filter>';

    // Masker: wit = passe-partout zichtbaar, zwart = opening (transparant)
    const maskRects = openingRects.map(r => {
      const cx = (r.x + r.w / 2).toFixed(1), cy = (r.y + r.h / 2).toFixed(1);
      const rect = '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
        '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '" fill="black"/>';
      return r.rot ? '<g transform="rotate(' + r.rot + ',' + cx + ',' + cy + ')">' + rect + '</g>' : rect;
    }).join('');

    const ppMask =
      '<mask id="ppb-pp-mask">' +
        '<rect width="' + svgW + '" height="' + svgH + '" fill="white"/>' +
        maskRects +
      '</mask>';

    // ClipPaths per opening (voor foto)
    const clipPaths = openingRects.map((r, i) => {
      const cx = (r.x + r.w / 2).toFixed(1), cy = (r.y + r.h / 2).toFixed(1);
      const rect = '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
        '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
        (r.rot ? ' transform="rotate(' + r.rot + ',' + cx + ',' + cy + ')"' : '') + '/>';
      return '<clipPath id="ppb-clip-' + i + '">' + rect + '</clipPath>';
    }).join('');

    const parts = [];

    // Achtergrond (gesimuleerde muur)
    parts.push('<rect width="' + svgW + '" height="' + svgH + '" fill="' + bgColor + '"/>');

    // Elke opening: eigen foto of lege achtergrond
    openingRects.forEach(function (r, i) {
      const rcx = (r.x + r.w / 2).toFixed(1), rcy = (r.y + r.h / 2).toFixed(1);
      const rotAttr = r.rot ? ' transform="rotate(' + r.rot + ',' + rcx + ',' + rcy + ')"' : '';
      if (r.photoDataUrl) {
        var photoX, photoY, photoW, photoH;
        if (r.photoW && r.photoH) {
          photoW = r.photoW * scale;
          photoH = r.photoH * scale;
          photoX = r.x + (r.w - photoW) / 2;
          photoY = r.y + (r.h - photoH) / 2;
        } else {
          photoW = r.w;
          photoH = r.h;
          photoX = r.x;
          photoY = r.y;
        }
        parts.push(
          '<image href="' + r.photoDataUrl + '"' +
          ' x="' + photoX.toFixed(1) + '" y="' + photoY.toFixed(1) + '"' +
          ' width="' + photoW.toFixed(1) + '" height="' + photoH.toFixed(1) + '"' +
          rotAttr +
          ' clip-path="url(#ppb-clip-' + i + ')"' +
          ' preserveAspectRatio="xMidYMid meet"/>'
        );
      } else {
        parts.push(
          '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
          '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
          rotAttr + ' fill="' + bgColor + '"/>'
        );
        parts.push(
          '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
          '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
          rotAttr + ' fill="none" stroke="rgba(0,0,0,0.12)" stroke-width="1.5"/>'
        );
      }
      // Rode overlay voor overlappende openingen (onder de PP-laag)
      if (overlappingIndices.has(i)) {
        parts.push(
          '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
          '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
          rotAttr + ' fill="rgba(220,50,50,0.35)"/>'
        );
      }
    });

    // Passe-partout met textuurpatroon en masker voor de openingen
    parts.push(
      '<rect width="' + svgW + '" height="' + svgH + '"' +
      ' fill="url(#' + patternId + ')"' +
      ' mask="url(#ppb-pp-mask)"' +
      ' filter="url(#ppb-shadow)"/>'
    );

    // Subtiele bevel voor lichte kleuren
    if (color.light) {
      parts.push(
        '<rect width="' + svgW + '" height="' + svgH + '"' +
        ' fill="none" stroke="rgba(0,0,0,0.08)" stroke-width="1"' +
        ' mask="url(#ppb-pp-mask)"/>'
      );
    }

    // Rode rand bovenop PP-laag voor overlappende openingen
    openingRects.forEach(function (r, i) {
      if (overlappingIndices.has(i)) {
        const rcx = (r.x + r.w / 2).toFixed(1), rcy = (r.y + r.h / 2).toFixed(1);
        const rotAttr = r.rot ? ' transform="rotate(' + r.rot + ',' + rcx + ',' + rcy + ')"' : '';
        parts.push(
          '<rect x="' + r.x.toFixed(1) + '" y="' + r.y.toFixed(1) +
          '" width="' + r.w.toFixed(1) + '" height="' + r.h.toFixed(1) + '"' +
          rotAttr + ' fill="none" stroke="rgba(200,0,0,0.9)" stroke-width="2.5"' +
          ' style="pointer-events:none"/>'
        );
      }
    });

    // Openingsnummer per opening
    openingRects.forEach(function (r, i) {
      var cx = (r.x + r.w / 2).toFixed(1);
      var cy = (r.y + r.h / 2).toFixed(1);
      var fs = (Math.max(14, Math.min(r.w, r.h) * 0.38) * 3).toFixed(0);
      parts.push(
        '<text x="' + cx + '" y="' + cy + '"' +
        ' text-anchor="middle" dominant-baseline="central" dy="0.1em"' +
        ' font-size="' + fs + '" font-weight="400" font-family="LittleKidsHandwriting, cursive"' +
        ' fill="rgba(0,0,0,0.20)"' +
        ' clip-path="url(#ppb-clip-' + i + ')"' +
        ' style="pointer-events:none;user-select:none">' +
        (i + 1) + '</text>'
      );
    });

    // Selectie-highlight: stippellijn langs de volledige binnenrand
    openingRects.forEach(function (r, i) {
      if (!state.selectedOpenings.has(i)) return;
      const sw = 4;
      const ins = sw / 2;
      const rx = (r.x + ins).toFixed(1), ry = (r.y + ins).toFixed(1);
      const rw = (r.w - sw).toFixed(1), rh = (r.h - sw).toFixed(1);
      const rcx = (r.x + r.w / 2).toFixed(1), rcy = (r.y + r.h / 2).toFixed(1);
      const rotAttr = r.rot ? ' transform="rotate(' + r.rot + ',' + rcx + ',' + rcy + ')"' : '';
      const clip = 'clip-path="url(#ppb-clip-' + i + ')" style="pointer-events:none"';
      // Witte achtergrondslag voor contrast op elke PP-kleur
      parts.push(
        '<rect x="' + rx + '" y="' + ry + '" width="' + rw + '" height="' + rh + '"' +
        rotAttr + ' fill="none" stroke="white" stroke-width="' + (sw + 3) + '"' +
        ' stroke-dasharray="10 6" ' + clip + '/>'
      );
      // Oranje stippellijn
      parts.push(
        '<rect x="' + rx + '" y="' + ry + '" width="' + rw + '" height="' + rh + '"' +
        rotAttr + ' fill="none" stroke="#e67000" stroke-width="' + sw + '"' +
        ' stroke-dasharray="10 6" ' + clip + '/>'
      );
    });

    // Snap-lijnen (alignmentgidsen tijdens verslepen)
    // Snap-lijnen tijdens verslepen (rood, alleen bij uitlijning op kadermidden of andere openings)
    snapLines.forEach(function (line) {
      if (line.axis === 'v') {
        parts.push('<line x1="' + line.pos.toFixed(1) + '" y1="0" x2="' + line.pos.toFixed(1) + '" y2="' + svgH + '"' +
          ' stroke="#e33" stroke-width="1" stroke-dasharray="4 3" style="pointer-events:none"/>');
      } else {
        parts.push('<line x1="0" y1="' + line.pos.toFixed(1) + '" x2="' + svgW + '" y2="' + line.pos.toFixed(1) + '"' +
          ' stroke="#e33" stroke-width="1" stroke-dasharray="4 3" style="pointer-events:none"/>');
      }
    });

    return '<svg' +
      ' viewBox="0 0 ' + svgW + ' ' + svgH + '"' +
      ' width="' + svgW + '" height="' + svgH + '"' +
      ' xmlns="http://www.w3.org/2000/svg"' +
      ' role="img"' +
      ' aria-label="' + T.svgAria.replace('{label}', fmt.label).replace('{mat}', state.material).replace('{col}', color.name) + '"' +
      '><defs>' + shadowFilter + texturePattern + ppMask + clipPaths + '</defs>' +
      parts.join('') +
      '</svg>';
  }

  // ----------------------------------------------------------------
  // Openings info
  // ----------------------------------------------------------------

  function updateOpeningInfo() {
    const el = document.getElementById('ppb-opening-info');
    if (!el) return;

    const fmt = getActiveFormat();
    const errors = validateAll();

    if (errors.length > 0) {
      el.innerHTML = '<tr><td colspan="2" style="color:#c0392b">' + errors[0] + '</td></tr>';
      return;
    }

    const matLabel = state.material === 'linnenstof' ? T.matLinen : T.matStandard;

    let html =
      '<tr><td>' + T.labelFormat   + '</td><td>' + fmt.label    + '</td></tr>' +
      '<tr><td>' + T.labelMaterial + '</td><td>' + matLabel     + '</td></tr>' +
      '<tr><td>' + T.labelColour   + '</td><td>' + state.color  + '</td></tr>' +
      '<tr><td>' + T.labelOpenings + '</td><td>' + state.openings + '</td></tr>';

    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const label = state.openings > 1 ? T.labelOpening + ' ' + (i + 1) : T.labelInnerSize;
      html += '<tr><td>' + label + '</td><td>' +
        od.w.toFixed(1) + ' \u00d7 ' + od.h.toFixed(1) + ' cm</td></tr>';
      if (od.rotation) {
        const rotLabel = state.openings > 1 ? T.labelRotation + ' ' + (i + 1) : T.labelRotation;
        html += '<tr><td>' + rotLabel + '</td><td>' + od.rotation + '\u00b0</td></tr>';
      }
    }

    el.innerHTML = html;
  }

  // ----------------------------------------------------------------
  // Per-opening positie- en maatinvoer (dynamisch)
  // ----------------------------------------------------------------

  function getDefaultLeft(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    return ((fmt.w - od.w) / 2).toFixed(1);
  }

  function getDefaultTop(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    return ((fmt.h - od.h) / 2).toFixed(1);
  }

  function getDerivedRight(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    const left = od.left !== null ? od.left : (fmt.w - od.w) / 2;
    return Math.max(0, fmt.w - left - od.w);
  }

  function getDerivedBottom(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    const top = od.top !== null ? od.top : (fmt.h - od.h) / 2;
    return Math.max(0, fmt.h - top - od.h);
  }

  function getEffectiveLeft(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    return od.left !== null ? od.left : (fmt.w - od.w) / 2;
  }

  function getEffectiveTop(i) {
    const fmt = getActiveFormat();
    const od = state.openingPositions[i];
    return od.top !== null ? od.top : (fmt.h - od.h) / 2;
  }

  function renderPositionInputs() {
    const container = document.getElementById('ppb-positions-container');
    if (!container) return;

    // Stap 5 (globale foto-upload) tonen bij 1 opening, verbergen bij meerdere
    const step5 = document.getElementById('ppb-step-foto');
    if (step5) step5.style.display = state.openings > 1 ? 'none' : '';

    let html = '';
    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const leftVal = od.left !== null ? od.left : getDefaultLeft(i);
      const topVal  = od.top  !== null ? od.top  : getDefaultTop(i);

      const isSelected = state.selectedOpenings.has(i);
      html += '<div class="ppb-position-block' + (isSelected ? ' ppb-position-block--selected' : '') + '" data-opening="' + i + '">';
      html += '<div class="ppb-position-header">';
      html += '<p class="ppb-position-label">' + T.labelOpening + ' ' + (i + 1) + '</p>';
      if (state.openings >= 2) {
        html += '<label class="ppb-select-label">' +
          '<input type="checkbox" class="ppb-select-cb" data-opening="' + i + '"' +
          (isSelected ? ' checked' : '') + '>' +
          ' ' + T.labelSelect + '</label>';
      }
      html += '</div>';

      // Binnenmaat per opening
      html +=
        '<div class="ppb-position-grid ppb-size-grid">' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-size-' + i + '-w">' + T.labelWidth + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-size-input"' +
              ' id="ppb-size-' + i + '-w" data-opening="' + i + '" data-dim="w"' +
              ' value="' + od.w + '" min="' + MIN_OPENING + '" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-size-' + i + '-h">' + T.labelHeight + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-size-input"' +
              ' id="ppb-size-' + i + '-h" data-opening="' + i + '" data-dim="h"' +
              ' value="' + od.h + '" min="' + MIN_OPENING + '" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
        '</div>';

      // Positie per opening — Links|Rechts, dan Boven|Onder
      html +=
        '<div class="ppb-position-grid">' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-pos-' + i + '-left">' + T.labelLeft + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-pos-input"' +
              ' id="ppb-pos-' + i + '-left"' +
              ' data-opening="' + i + '" data-side="left"' +
              ' value="' + leftVal + '" min="0" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-pos-' + i + '-right">' + T.labelRight + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-pos-input"' +
              ' id="ppb-pos-' + i + '-right"' +
              ' data-opening="' + i + '" data-side="right"' +
              ' value="' + getDerivedRight(i).toFixed(1) + '" min="0" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-pos-' + i + '-top">' + T.labelTop + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-pos-input"' +
              ' id="ppb-pos-' + i + '-top"' +
              ' data-opening="' + i + '" data-side="top"' +
              ' value="' + topVal + '" min="0" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
          '<div class="ppb-margin-field">' +
            '<label for="ppb-pos-' + i + '-bottom">' + T.labelBottom + '</label>' +
            '<div class="ppb-input-row">' +
              '<input type="number" class="ppb-margin-number ppb-pos-input"' +
              ' id="ppb-pos-' + i + '-bottom"' +
              ' data-opening="' + i + '" data-side="bottom"' +
              ' value="' + getDerivedBottom(i).toFixed(1) + '" min="0" step="0.5">' +
              '<span class="ppb-margin-unit">cm</span>' +
            '</div>' +
          '</div>' +
        '</div>';

      // Rotatie-stepper
      const rot = od.rotation || 0;
      html +=
        '<div class="ppb-rotation-row">' +
          '<span class="ppb-rotation-label">' + T.labelRotate + '</span>' +
          '<button type="button" class="ppb-rotate-btn" data-opening="' + i + '" data-dir="-1">−5°</button>' +
          '<span class="ppb-rotation-display">' + rot + '°</span>' +
          '<button type="button" class="ppb-rotate-btn" data-opening="' + i + '" data-dir="1">+5°</button>' +
        '</div>';

      // Centreer-knoppen
      html +=
        '<div class="ppb-center-row">' +
          '<span class="ppb-center-label">' + T.labelCentre + '</span>' +
          '<button type="button" class="ppb-center-quick-btn" data-opening="' + i + '" data-axis="h" title="Horizontaal centreren">' +
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<rect x="3" y="5" width="12" height="8" rx="1"/>' +
              '<line x1="9" y1="1" x2="9" y2="17"/>' +
            '</svg>' +
          '</button>' +
          '<button type="button" class="ppb-center-quick-btn" data-opening="' + i + '" data-axis="v" title="Verticaal centreren">' +
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<rect x="5" y="3" width="8" height="12" rx="1"/>' +
              '<line x1="1" y1="9" x2="17" y2="9"/>' +
            '</svg>' +
          '</button>' +
          '<button type="button" class="ppb-center-quick-btn" data-opening="' + i + '" data-axis="both" title="Centreren in beide richtingen">' +
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<rect x="5" y="5" width="8" height="8" rx="1"/>' +
              '<line x1="9" y1="1" x2="9" y2="17"/>' +
              '<line x1="1" y1="9" x2="17" y2="9"/>' +
            '</svg>' +
          '</button>' +
        '</div>';

      // Standaard maten knop per opening
      html +=
        '<div class="ppb-opening-cheatsheet-row">' +
          '<button type="button" class="ppb-cheatsheet-btn ppb-cheatsheet-btn--inline" data-opening-target="' + i + '">' +
            T.cheatsheetBtn +
          '</button>' +
        '</div>';

      // Foto per opening (alleen tonen bij meerdere openingen)
      if (state.openings > 1) {
        html += '<div class="ppb-foto-per-opening">';
        if (od.photoDataUrl) {
          html +=
            '<p class="ppb-photo-filename" id="ppb-photo-name-' + i + '">' + T.photoLoaded + '</p>' +
            '<button type="button" class="ppb-photo-remove ppb-photo-remove-per"' +
            ' data-opening="' + i + '">' + T.photoRemove + '</button>';
        } else {
          html +=
            '<label for="ppb-photo-input-' + i + '" class="ppb-photo-label ppb-photo-label--small">' +
            T.photoUpload + '</label>' +
            '<input type="file" class="ppb-photo-input ppb-photo-input-per"' +
            ' id="ppb-photo-input-' + i + '" data-opening="' + i + '" accept="image/*">';
        }
        html += '</div>';
      }

      html += '</div>'; // einde ppb-position-block
    }

    container.innerHTML = html;

    // Events: centreer-knoppen per opening
    container.querySelectorAll('.ppb-center-quick-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const idx = parseInt(btn.dataset.opening, 10);
        const axis = btn.dataset.axis;
        const fmt = getActiveFormat();
        const od = state.openingPositions[idx];
        if (axis === 'h' || axis === 'both') {
          od.left = parseFloat(((fmt.w - od.w) / 2).toFixed(2));
        }
        if (axis === 'v' || axis === 'both') {
          od.top = parseFloat(((fmt.h - od.h) / 2).toFixed(2));
        }
        renderPositionInputs();
        update();
      });
    });

    // Events: binnenmaat per opening
    container.querySelectorAll('.ppb-size-input').forEach(function (inp) {
      inp.addEventListener('input', function () {
        const idx = parseInt(inp.dataset.opening, 10);
        const dim = inp.dataset.dim;
        state.openingPositions[idx][dim] = parseFloat(inp.value) || 1;
        update();
      });
    });

    // Events: positie per opening
    container.querySelectorAll('.ppb-pos-input').forEach(function (inp) {
      inp.addEventListener('input', function () {
        const idx = parseInt(inp.dataset.opening, 10);
        const side = inp.dataset.side;
        const val = parseFloat(inp.value);
        if (isNaN(val)) return;
        const fmt = getActiveFormat();
        const od = state.openingPositions[idx];

        // Bereken de nieuwe left/top voor de gewijzigde opening
        const oldLeft = od.left !== null ? od.left : (fmt.w - od.w) / 2;
        const oldTop  = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;
        let newLeft = oldLeft;
        let newTop  = oldTop;
        if (side === 'left')   newLeft = val;
        if (side === 'top')    newTop  = val;
        if (side === 'right')  newLeft = parseFloat((fmt.w - od.w - val).toFixed(2));
        if (side === 'bottom') newTop  = parseFloat((fmt.h - od.h - val).toFixed(2));

        const dLeft = newLeft - oldLeft;
        const dTop  = newTop  - oldTop;

        // Verplaats alle geselecteerde openings met dezelfde delta
        const targets = (state.selectedOpenings.size > 1 && state.selectedOpenings.has(idx))
          ? Array.from(state.selectedOpenings)
          : [idx];

        targets.forEach(function (si) {
          const sod = state.openingPositions[si];
          const sl  = sod.left !== null ? sod.left : (fmt.w - sod.w) / 2;
          const st  = sod.top  !== null ? sod.top  : (fmt.h - sod.h) / 2;
          if (side === 'left' || side === 'right')  sod.left = parseFloat((sl + dLeft).toFixed(2));
          if (side === 'top'  || side === 'bottom') sod.top  = parseFloat((st + dTop ).toFixed(2));
        });

        update();
      });
    });

    // Events: foto upload per opening
    container.querySelectorAll('.ppb-photo-input-per').forEach(function (inp) {
      inp.addEventListener('change', function () {
        const idx = parseInt(inp.dataset.opening, 10);
        const file = inp.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = function (e) {
          resizeImage(e.target.result, 800, function (resized) {
            state.openingPositions[idx].photoDataUrl = resized;
            renderPositionInputs();
            update();
          });
        };
        reader.readAsDataURL(file);
      });
    });

    // Events: foto verwijderen per opening
    container.querySelectorAll('.ppb-photo-remove-per').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const idx = parseInt(btn.dataset.opening, 10);
        state.openingPositions[idx].photoDataUrl = null;
        state.openingPositions[idx].photoW = null;
        state.openingPositions[idx].photoH = null;
        renderPositionInputs();
        update();
      });
    });

    // Events: selectie-checkboxes
    container.querySelectorAll('.ppb-select-cb').forEach(function (cb) {
      cb.addEventListener('change', function () {
        const idx = parseInt(cb.dataset.opening, 10);
        if (cb.checked) {
          state.selectedOpenings.add(idx);
        } else {
          state.selectedOpenings.delete(idx);
        }
        update();
      });
    });

    // Events: rotatie-knoppen
    container.querySelectorAll('.ppb-rotate-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        saveHistory();
        const idx = parseInt(btn.dataset.opening, 10);
        const dir = parseInt(btn.dataset.dir, 10);
        const od = state.openingPositions[idx];
        od.rotation = ((od.rotation || 0) + dir * 5 + 360) % 360;
        renderPositionInputs();
        update();
      });
    });
  }

  function updateDerivedPositions() {
    for (let i = 0; i < state.openings; i++) {
      const leftInp   = document.getElementById('ppb-pos-' + i + '-left');
      const topInp    = document.getElementById('ppb-pos-' + i + '-top');
      const rightInp  = document.getElementById('ppb-pos-' + i + '-right');
      const bottomInp = document.getElementById('ppb-pos-' + i + '-bottom');
      if (leftInp   && document.activeElement !== leftInp)   leftInp.value   = getEffectiveLeft(i).toFixed(1);
      if (topInp    && document.activeElement !== topInp)    topInp.value    = getEffectiveTop(i).toFixed(1);
      if (rightInp  && document.activeElement !== rightInp)  rightInp.value  = getDerivedRight(i).toFixed(1);
      if (bottomInp && document.activeElement !== bottomInp) bottomInp.value = getDerivedBottom(i).toFixed(1);
    }
  }

  function syncSelectionCheckboxes() {
    for (let i = 0; i < state.openings; i++) {
      const cb = document.querySelector('.ppb-select-cb[data-opening="' + i + '"]');
      if (cb) cb.checked = state.selectedOpenings.has(i);
      const block = document.querySelector('.ppb-position-block[data-opening="' + i + '"]');
      if (block) block.classList.toggle('ppb-position-block--selected', state.selectedOpenings.has(i));
    }
  }

  // ----------------------------------------------------------------
  // Shopify variant matching
  // ----------------------------------------------------------------

  function findVariant() {
    const product = window.PassePartoutProduct;
    if (!product || !product.variants) return null;

    const baseKey = state.customFormat ? getCustomFormatBaseKey() : state.format;
    const mat     = state.material === 'linnenstof' ? 'Linnenstof' : 'Standaard';

    const matKey = state.material === 'linnenstof' ? 'linnenstof' : 'standaard';
    // Shopify slaat prijzen op in centen (integer)
    const basePriceCents = Math.round((PRICES[baseKey] && PRICES[baseKey][matKey] || 0) * 100);
    // Materiaal-zoekwoorden in NL en EN
    const matWords = state.material === 'linnenstof'
      ? ['linnenstof', 'linen']
      : ['standaard', 'standard'];

    function matchesMat(v) {
      var opt2 = (v.option2 || '').toLowerCase();
      return matWords.some(function (w) { return opt2.indexOf(w) !== -1; });
    }

    // 1. Prijs in centen + materiaal
    var variant = null;
    if (basePriceCents) {
      variant = product.variants.find(function (v) {
        return parseInt(v.price, 10) === basePriceCents && matchesMat(v);
      });
      // 2. Alleen prijs (als materiaal niet matcht)
      if (!variant) {
        variant = product.variants.find(function (v) {
          return parseInt(v.price, 10) === basePriceCents;
        });
      }
    }

    return variant || null;
  }

  // ----------------------------------------------------------------
  // Cart preview SVG (compact, voor winkelwagen-thumbnail)
  // ----------------------------------------------------------------

  /**
   * Genereer een SVG-preview van het huidige ontwerp als data URI.
   * Gebruikt de state (kleur, openingen, marges) — geen DOM-capture nodig.
   * Gegarandeerd te werken als img src.
   */
  function capturePreviewFromDOM() {
    try {
      var color = getActiveColor();
      var fill  = color.texture === 'linen' ? '#cfcec4' : color.hex;

      /* Openingskleur contrasteert altijd met de mat:
         lichte mat → donkergrijs opening, donkere mat → lichtgrijs opening */
      var openingFill = color.light ? '#9a9a9a' : '#d8d8d8';

      /* Altijd een vierkante thumbnail (200×200) */
      var S   = 200;
      var pad = 28; /* marge rondom formaat */

      /* SVG-achtergrond: neutraal grijs zodat zelfs witte mats zichtbaar zijn */
      var bgFill = '#d4d4d4';

      /* Probeer echte openingen te berekenen als alles valid is */
      var shapes = '';
      try {
        if (validateFormat().length === 0 && validateOpeningSize().length === 0) {
          var fmt = getActiveFormat();
          var inner = S - 2 * pad;
          var sc;
          if (fmt.w >= fmt.h) { sc = inner / fmt.w; }
          else                 { sc = inner / fmt.h; }
          var fmtW = fmt.w * sc;
          var fmtH = fmt.h * sc;
          var offX = (S - fmtW) / 2;
          var offY = (S - fmtH) / 2;

          /* Mat-rechthoek */
          shapes += '<rect x="' + offX.toFixed(1) + '" y="' + offY.toFixed(1) +
                    '" width="' + fmtW.toFixed(1) + '" height="' + fmtH.toFixed(1) +
                    '" fill="' + fill + '"/>';

          /* Openingen */
          getOpeningRects(fmt, sc).forEach(function (od) {
            shapes += '<rect x="' + (offX + od.x).toFixed(1) +
                      '" y="' + (offY + od.y).toFixed(1) +
                      '" width="' + od.w.toFixed(1) +
                      '" height="' + od.h.toFixed(1) +
                      '" fill="' + openingFill + '"/>';
          });

          /* Randje om de mat */
          shapes += '<rect x="' + offX.toFixed(1) + '" y="' + offY.toFixed(1) +
                    '" width="' + fmtW.toFixed(1) + '" height="' + fmtH.toFixed(1) +
                    '" fill="none" stroke="rgba(0,0,0,0.25)" stroke-width="1.5"/>';
        }
      } catch (_) {}

      /* Fallback: gecentreerde opening */
      if (!shapes) {
        shapes = '<rect x="' + pad + '" y="' + pad + '"' +
                 ' width="' + (S - 2 * pad) + '" height="' + (S - 2 * pad) + '"' +
                 ' fill="' + fill + '"/>' +
                 '<rect x="' + (pad + 28) + '" y="' + (pad + 28) + '"' +
                 ' width="' + (S - 2 * (pad + 28)) + '" height="' + (S - 2 * (pad + 28)) + '"' +
                 ' fill="' + openingFill + '"/>' +
                 '<rect x="' + pad + '" y="' + pad + '"' +
                 ' width="' + (S - 2 * pad) + '" height="' + (S - 2 * pad) + '"' +
                 ' fill="none" stroke="rgba(0,0,0,0.25)" stroke-width="1.5"/>';
      }

      var svg = '<svg xmlns="http://www.w3.org/2000/svg"' +
                ' viewBox="0 0 ' + S + ' ' + S + '"' +
                ' width="' + S + '" height="' + S + '">' +
                '<rect width="' + S + '" height="' + S + '" fill="' + bgFill + '"/>' +
                shapes +
                '</svg>';

      return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
    } catch (e) {
      return '';
    }
  }

  function generateCartPreviewSVG() {
    const fmt   = getActiveFormat();
    const color = getActiveColor();
    const fill  = color.texture === 'linen' ? '#cfcec4' : color.hex;
    const W     = 100;
    const H     = Math.round(100 * fmt.h / fmt.w);
    const sc    = W / fmt.w;

    let rects = '';
    if (validateFormat().length === 0 && validateOpeningSize().length === 0) {
      getOpeningRects(fmt, sc).forEach(function (od) {
        rects += '<rect x="' + od.x.toFixed(1) + '" y="' + od.y.toFixed(1) +
                 '" width="' + od.w.toFixed(1) + '" height="' + od.h.toFixed(1) +
                 '" fill="white"/>';
      });
    }

    const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '">' +
                '<rect width="' + W + '" height="' + H + '" fill="' + fill + '"/>' +
                rects + '</svg>';
    try { return 'data:image/svg+xml;base64,' + btoa(svg); }
    catch (e) { return ''; }
  }

  // ----------------------------------------------------------------
  // Preview payload (voor URL-gebaseerde preview-pagina)
  // ----------------------------------------------------------------

  function buildPreviewPayload() {
    var fmt   = getActiveFormat();
    var color = getActiveColor();
    var fill  = color.texture === 'linen' ? '#cfcec4' : color.hex;
    var o = getOpeningRects(fmt, 1).map(function (r) {
      return {
        x: +r.x.toFixed(1), y: +r.y.toFixed(1),
        w: +r.w.toFixed(1), h: +r.h.toFixed(1),
      };
    });
    return { w: fmt.w, h: fmt.h, fill: fill, label: fmt.label, color: state.color, o: o };
  }

  function encodePreviewParam(payload) {
    var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
  }

  // ----------------------------------------------------------------
  // Shopify Cart API
  // ----------------------------------------------------------------

  async function addToCart() {
    const errors = validateAll();
    if (errors.length > 0) {
      showFeedback(errors[0], 'error');
      return;
    }

    const variant = findVariant();
    if (!variant) {
      showFeedback(T.productNotFound, 'error');
      return;
    }

    const fmt = getActiveFormat();
    const localePrefix = isEN ? '/en/' : '/';
    const previewUrl = window.location.origin + localePrefix + 'pages/passe-partout-preview?d=' +
                       encodePreviewParam(buildPreviewPayload());

    const properties = {
      [T.cartColour]:    state.color,
      [T.cartOpenings]:  String(state.openings),
      '_Formaat':        fmt.label,
      '_Materiaal':      state.material === 'linnenstof' ? 'Linnenstof' : 'Standaard',
      '_prijs':          getPrice().toFixed(2),
      '_ppb':            '1',
      [T.cartPreview]:   previewUrl,
    };

    for (let i = 0; i < state.openings; i++) {
      const od     = state.openingPositions[i];
      const left   = parseFloat((od.left !== null ? od.left : (fmt.w - od.w) / 2).toFixed(1));
      const top    = parseFloat((od.top  !== null ? od.top  : (fmt.h - od.h) / 2).toFixed(1));
      const right  = parseFloat((fmt.w - left - od.w).toFixed(1));
      const bottom = parseFloat((fmt.h - top  - od.h).toFixed(1));
      const pfx    = state.openings > 1 ? T.openingPrefix + (i + 1) + ' ' : '';
      properties[pfx + T.cartInnerSize]    = od.w.toFixed(1) + ' \u00d7 ' + od.h.toFixed(1) + ' cm';
      properties[pfx + T.cartMarginLeft]   = left   + ' cm';
      properties[pfx + T.cartMarginRight]  = right  + ' cm';
      properties[pfx + T.cartMarginTop]    = top    + ' cm';
      properties[pfx + T.cartMarginBottom] = bottom + ' cm';
    }

    const addBtn = document.getElementById('ppb-add-btn');
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');
    addBtn.textContent = T.adding;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties }] }),
      });

      const resData = await res.json().catch(function () { return {}; });
      if (!res.ok) throw new Error(resData.description || 'HTTP ' + res.status);

      showFeedback(T.addedToCart, 'success');

      // Open Essential Cart drawer + update cart count
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const cartCount = document.querySelector('[data-cart-count], .cart-count, .header__cart-count');
        if (cartCount) cartCount.textContent = cart.item_count;
        // Trigger Essential Cart drawer to open
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('on:cart:updated', { detail: { cart: cart } }));
        // Also try direct drawer open methods used by different cart apps
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
      } catch (_) { /* negeren */ }

    } catch (err) {
      showFeedback(T.addError + err.message, 'error');
    } finally {
      addBtn.disabled = false;
      addBtn.classList.remove('is-loading');
      addBtn.textContent = T.addToCart;
    }
  }

  // ----------------------------------------------------------------
  // UI feedback
  // ----------------------------------------------------------------

  function showFeedback(msg, type) {
    const el = document.getElementById('ppb-feedback');
    if (!el) return;
    el.textContent = msg;
    el.className = 'ppb-feedback ' + (type === 'error' ? 'is-error' : 'is-success');
    if (type === 'success') {
      setTimeout(function () { el.textContent = ''; el.className = 'ppb-feedback'; }, 4000);
    }
  }

  // ----------------------------------------------------------------
  // Render / Update
  // ----------------------------------------------------------------

  function updateOverlapWarning() {
    const el = document.getElementById('ppb-overlap-warning');
    if (!el) return;
    const posErrors = validatePositions();
    // Filter on "too close" errors (both NL and EN), not border-proximity errors
    const overlapErrors = posErrors.filter(function (e) {
      return e.indexOf('te dicht bij elkaar') !== -1 || e.indexOf('too close together') !== -1;
    });
    if (overlapErrors.length > 0) {
      el.textContent = '\u26a0\ufe0f ' + overlapErrors.join('. ') + '.';
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function update() {
    updatePreview();
    updatePrice();
    updateOpeningInfo();
    updateDerivedPositions();
    updateOverlapWarning();
    updateAddButton();
    updateAlignToolbar();
    syncSelectionCheckboxes();
  }

  function updatePreview() {
    const canvas = document.getElementById('ppb-preview-svg');
    if (!canvas) return;
    canvas.innerHTML = renderSVG();
    attachSVGInteraction();
  }

  function updatePrice() {
    const el = document.getElementById('ppb-price-value');
    if (!el) return;
    const fmtErrors = validateFormat();
    if (fmtErrors.length > 0) {
      el.textContent = '\u2013';
      return;
    }
    const price = getPrice();
    let label = formatPrice(price);
    if (state.customFormat) {
      const baseKey = getCustomFormatBaseKey();
      const baseFmt = FORMATS.find(function (f) { return f.key === baseKey; });
      const baseLabel = baseFmt ? baseFmt.label : (isEN ? 'Small size' : 'Klein formaat');
      label += T.basedOn.replace('{label}', baseLabel);
    }
    el.textContent = label;
  }

  function updateAddButton() {
    const btn = document.getElementById('ppb-add-btn');
    if (!btn) return;
    const errors = validateAll();
    btn.disabled = errors.length > 0;

    const errEl = document.getElementById('ppb-opening-error');
    if (errEl) {
      const sizeErrors = validateOpeningSize();
      const posErrors  = validatePositions();
      const relevant = [...sizeErrors, ...posErrors];
      errEl.textContent = relevant.length > 0 ? relevant[0] : '';
    }
  }

  function centerInFrame(axis) {
    const fmt = getActiveFormat();
    const indices = Array.from(state.selectedOpenings);
    if (!indices.length) return;
    saveHistory();

    const snapshots = indices.map(function (i) {
      return { i: i, left: state.openingPositions[i].left, top: state.openingPositions[i].top };
    });

    // Pre-compute effective positions zodat we de groep als geheel kunnen centreren
    const eff = {};
    indices.forEach(function (i) {
      eff[i] = { left: getEffectiveLeft(i), top: getEffectiveTop(i) };
    });

    if (axis === 'h' || axis === 'both') {
      let minLeft = Infinity, maxRight = -Infinity;
      indices.forEach(function (i) {
        minLeft  = Math.min(minLeft,  eff[i].left);
        maxRight = Math.max(maxRight, eff[i].left + state.openingPositions[i].w);
      });
      const dLeft = (fmt.w - (maxRight - minLeft)) / 2 - minLeft;
      indices.forEach(function (i) {
        state.openingPositions[i].left = parseFloat((eff[i].left + dLeft).toFixed(2));
      });
    }

    if (axis === 'v' || axis === 'both') {
      let minTop = Infinity, maxBottom = -Infinity;
      indices.forEach(function (i) {
        minTop    = Math.min(minTop,    eff[i].top);
        maxBottom = Math.max(maxBottom, eff[i].top + state.openingPositions[i].h);
      });
      const dTop = (fmt.h - (maxBottom - minTop)) / 2 - minTop;
      indices.forEach(function (i) {
        state.openingPositions[i].top = parseFloat((eff[i].top + dTop).toFixed(2));
      });
    }

    var errors = validatePositions();
    if (errors.length > 0) {
      snapshots.forEach(function (s) {
        state.openingPositions[s.i].left = s.left;
        state.openingPositions[s.i].top  = s.top;
      });
      var alignErr = document.getElementById('ppb-align-error');
      if (alignErr) {
        alignErr.textContent = T.centreFailed + errors[0].toLowerCase();
        alignErr.style.display = '';
        clearTimeout(alignErr._timer);
        alignErr._timer = setTimeout(function () {
          alignErr.style.display = 'none';
          alignErr.textContent = '';
        }, 5000);
      }
      return;
    }

    var alignErr = document.getElementById('ppb-align-error');
    if (alignErr) { alignErr.style.display = 'none'; alignErr.textContent = ''; }

    renderPositionInputs();
    update();
  }

  function updateAlignToolbar() {
    const toolbar = document.getElementById('ppb-align-toolbar');
    if (!toolbar) return;
    const n = state.selectedOpenings.size;
    const show = n >= 1;
    toolbar.style.display = show ? '' : 'none';
    toolbar.setAttribute('aria-hidden', show ? 'false' : 'true');
    // Uitlijn-knoppen (links/rechts/boven/onder) alleen actief bij ≥2
    toolbar.querySelectorAll('.ppb-multi-btn').forEach(function (btn) {
      btn.disabled = n < 2;
      btn.style.opacity = n < 2 ? '0.35' : '';
    });
  }

  // ----------------------------------------------------------------
  // SVG drag & resize interactie
  // ----------------------------------------------------------------

  function computeSnapLines(dragIdx, left, top, w, h, scale) {
    const THRESH = 0.1; // cm (= 1mm)
    const seen = new Set();
    const lines = [];

    function addLine(axis, posCm) {
      const key = axis + posCm.toFixed(2);
      if (seen.has(key)) return;
      seen.add(key);
      lines.push({ axis: axis, pos: posCm * scale });
    }

    // Hulplijnen t.o.v. andere openings
    for (let i = 0; i < state.openings; i++) {
      if (i === dragIdx) continue;
      const od = state.openingPositions[i];
      const ox = [od.left, od.left + od.w, od.left + od.w / 2];
      const oy = [od.top,  od.top + od.h,  od.top  + od.h / 2];
      const dx = [left,    left + w,        left + w / 2];
      const dy = [top,     top  + h,        top  + h / 2];

      ox.forEach(function (ref) {
        dx.forEach(function (cand) {
          if (Math.abs(cand - ref) < THRESH) addLine('v', ref);
        });
      });
      oy.forEach(function (ref) {
        dy.forEach(function (cand) {
          if (Math.abs(cand - ref) < THRESH) addLine('h', ref);
        });
      });
    }

    return lines;
  }

  // Snap left/top naar dichtstbijzijnde uitlijning binnen drempel, geeft gecorrigeerde waarden terug
  function applySnap(dragIdx, left, top, w, h) {
    const THRESH = 0.1;
    const fmt = getActiveFormat();
    let snappedLeft = left, snappedTop = top;
    let bestDx = THRESH, bestDy = THRESH;

    for (let i = 0; i < state.openings; i++) {
      if (i === dragIdx) continue;
      const od = state.openingPositions[i];
      const ox = [od.left, od.left + od.w, od.left + od.w / 2];
      const oy = [od.top,  od.top + od.h,  od.top  + od.h / 2];

      // Kandidaat-x-posities van de sleepende opening
      [[left, 0], [left + w, -w], [left + w / 2, -w / 2]].forEach(function (pair) {
        const cand = pair[0], offset = pair[1];
        ox.forEach(function (ref) {
          const d = Math.abs(cand - ref);
          if (d < bestDx) { bestDx = d; snappedLeft = ref + offset; }
        });
      });

      // Kandidaat-y-posities van de sleepende opening
      [[top, 0], [top + h, -h], [top + h / 2, -h / 2]].forEach(function (pair) {
        const cand = pair[0], offset = pair[1];
        oy.forEach(function (ref) {
          const d = Math.abs(cand - ref);
          if (d < bestDy) { bestDy = d; snappedTop = ref + offset; }
        });
      });
    }

    return { left: snappedLeft, top: snappedTop };
  }

  function getSVGScale() {
    const fmt = getActiveFormat();
    return Math.min(340 / fmt.w, 420 / fmt.h);
  }

  function attachSVGInteraction() {
    const container = document.getElementById('ppb-preview-svg');
    if (!container) return;
    const svg = container.querySelector('svg');
    if (!svg) return;

    const sizeErrors = [...validateFormat(), ...validateOpeningSize()];
    if (sizeErrors.length > 0) return;

    const fmt   = getActiveFormat();
    const scale = getSVGScale();
    const HANDLE = 8;

    for (let i = 0; i < state.openings; i++) {
      const od   = state.openingPositions[i];
      const left = od.left !== null ? od.left : (fmt.w - od.w) / 2;
      const top  = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;

      const rx = left * scale;
      const ry = top  * scale;
      const rw = od.w  * scale;
      const rh = od.h  * scale;
      const rot = od.rotation || 0;

      // Groep met rotatie-transform zodat handles mee-roteren
      const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      if (rot) {
        const cx = (rx + rw / 2).toFixed(1);
        const cy = (ry + rh / 2).toFixed(1);
        g.setAttribute('transform', 'rotate(' + rot + ',' + cx + ',' + cy + ')');
      }
      svg.appendChild(g);

      // Transparante overlay voor verplaatsen
      addSVGHandle(g, rx, ry, rw, rh, 'transparent', 'move', i, 'move', '');

      // Resize-hoekjes
      [
        { dx: 0,            dy: 0,            cur: 'nw-resize', d: 'nw' },
        { dx: rw - HANDLE,  dy: 0,            cur: 'ne-resize', d: 'ne' },
        { dx: 0,            dy: rh - HANDLE,  cur: 'sw-resize', d: 'sw' },
        { dx: rw - HANDLE,  dy: rh - HANDLE,  cur: 'se-resize', d: 'se' },
      ].forEach(function (h) {
        addSVGHandle(g, rx + h.dx, ry + h.dy, HANDLE, HANDLE,
          'rgba(255,255,255,0.85)', h.cur, i, 'resize', h.d);
      });
    }

    svg.addEventListener('mousedown', onSVGMousedown);
    svg.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) onSVGMousedown(e);
    }, { passive: false });
  }

  function addSVGHandle(parent, x, y, w, h, fill, cursor, idx, action, dir) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    el.setAttribute('x', x.toFixed(1));
    el.setAttribute('y', y.toFixed(1));
    el.setAttribute('width',  w.toFixed(1));
    el.setAttribute('height', h.toFixed(1));
    el.setAttribute('fill', fill);
    el.style.cursor = cursor;
    el.dataset.ppbOpening = String(idx);
    el.dataset.ppbAction  = action;
    el.dataset.ppbDir     = dir;
    if (action === 'resize') {
      el.setAttribute('stroke', '#1e61b9');
      el.setAttribute('stroke-width', '1.5');
      el.setAttribute('rx', '2');
    }
    parent.appendChild(el);
  }

  function onSVGMousedown(e) {
    const touch = e.touches && e.touches.length > 0;
    const target = touch ? document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY) : e.target;
    if (!target) return;

    // Tik/klik op achtergrond (geen opening-handle): selectie wissen
    if (target.dataset.ppbOpening === undefined) {
      if (state.selectedOpenings.size > 0) {
        e.preventDefault();
        state.selectedOpenings = new Set();
        update();
      }
      return;
    }
    e.preventDefault();
    saveHistory();

    const fmt   = getActiveFormat();
    const scale = getSVGScale();
    const i     = parseInt(target.dataset.ppbOpening, 10);
    const od    = state.openingPositions[i];
    const left  = od.left !== null ? od.left : (fmt.w - od.w) / 2;
    const top   = od.top  !== null ? od.top  : (fmt.h - od.h) / 2;

    // Sla startposities én -afmetingen op van alle geselecteerde openings
    const origPositions = {};
    const origSizes = {};
    state.selectedOpenings.forEach(function (si) {
      const sod = state.openingPositions[si];
      const sl  = sod.left !== null ? sod.left : (fmt.w - sod.w) / 2;
      const st  = sod.top  !== null ? sod.top  : (fmt.h - sod.h) / 2;
      origPositions[si] = { left: sl, top: st };
      origSizes[si]     = { w: sod.w, h: sod.h, cx: sl + sod.w / 2, cy: st + sod.h / 2 };
    });

    const startCoords = getEventCoords(e);
    svgDrag = {
      idx:          i,
      action:       target.dataset.ppbAction,
      dir:          target.dataset.ppbDir || '',
      startX:       startCoords.clientX,
      startY:       startCoords.clientY,
      origLeft:     left,
      origTop:      top,
      origW:        od.w,
      origH:        od.h,
      origPositions: origPositions,
      origSizes:    origSizes,
      scale:        scale,
      fmt:          fmt,
      moved:        false,
    };
  }

  function getEventCoords(e) {
    if (e.touches && e.touches.length > 0) {
      return { clientX: e.touches[0].clientX, clientY: e.touches[0].clientY, shiftKey: false };
    }
    if (e.changedTouches && e.changedTouches.length > 0) {
      return { clientX: e.changedTouches[0].clientX, clientY: e.changedTouches[0].clientY, shiftKey: false };
    }
    return { clientX: e.clientX, clientY: e.clientY, shiftKey: e.shiftKey };
  }

  function initSVGDragListeners() {
    var rafPending = false;

    function onMove(e) {
      if (!svgDrag) return;

      const coords = getEventCoords(e);
      // Markeer als drag zodra de vinger/muis >3px beweegt (lager voor touch)
      if (!svgDrag.moved) {
        var totalDx = Math.abs(coords.clientX - svgDrag.startX);
        var totalDy = Math.abs(coords.clientY - svgDrag.startY);
        if (totalDx > 3 || totalDy > 3) svgDrag.moved = true;
      }
      if (!svgDrag.moved) return;

      e.preventDefault();

      // Throttle via requestAnimationFrame voor vloeiendere mobiele sleep
      svgDrag._lastCoords = coords;
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        if (!svgDrag) return;
        processMove(svgDrag._lastCoords);
      });
    }

    function processMove(coords) {

      const d   = svgDrag;
      const fmt = d.fmt;
      const dx  = (coords.clientX - d.startX) / d.scale;
      const dy  = (coords.clientY - d.startY) / d.scale;
      const od  = state.openingPositions[d.idx];

      if (d.action === 'move') {
        if (state.selectedOpenings.size > 1 && state.selectedOpenings.has(d.idx)) {
          // Multi-drag: bereken de werkelijke delta van de gesleepte opening
          // en pas diezelfde delta toe op alle geselecteerde openings
          const origMain = d.origPositions[d.idx];
          const clampedLeft = Math.max(MIN_MARGIN, Math.min(origMain.left + dx, fmt.w - od.w - MIN_MARGIN));
          const clampedTop  = Math.max(MIN_MARGIN, Math.min(origMain.top  + dy, fmt.h - od.h - MIN_MARGIN));
          const actualDx = clampedLeft - origMain.left;
          const actualDy = clampedTop  - origMain.top;
          state.selectedOpenings.forEach(function (si) {
            const sod  = state.openingPositions[si];
            const orig = d.origPositions[si];
            if (!orig) return;
            sod.left = parseFloat((orig.left + actualDx).toFixed(2));
            sod.top  = parseFloat((orig.top  + actualDy).toFixed(2));
          });
          snapLines = [];
        } else {
          let rawLeft = Math.max(MIN_MARGIN, Math.min(d.origLeft + dx, fmt.w - od.w - MIN_MARGIN));
          let rawTop  = Math.max(MIN_MARGIN, Math.min(d.origTop  + dy, fmt.h - od.h - MIN_MARGIN));
          const snapped = applySnap(d.idx, rawLeft, rawTop, od.w, od.h);
          rawLeft = Math.max(MIN_MARGIN, Math.min(snapped.left, fmt.w - od.w - MIN_MARGIN));
          rawTop  = Math.max(MIN_MARGIN, Math.min(snapped.top,  fmt.h - od.h - MIN_MARGIN));
          od.left = parseFloat(rawLeft.toFixed(2));
          od.top  = parseFloat(rawTop.toFixed(2));
          snapLines = state.openings > 1 ? computeSnapLines(d.idx, od.left, od.top, od.w, od.h, d.scale) : [];
        }
      } else {
        // resize
        let newLeft = d.origLeft;
        let newTop  = d.origTop;
        let newW    = d.origW;
        let newH    = d.origH;

        if (d.dir.includes('e')) newW = Math.max(MIN_OPENING, d.origW + dx);
        if (d.dir.includes('s')) newH = Math.max(MIN_OPENING, d.origH + dy);
        if (d.dir.includes('w')) { newW = Math.max(MIN_OPENING, d.origW - dx); newLeft = d.origLeft + (d.origW - newW); }
        if (d.dir.includes('n')) { newH = Math.max(MIN_OPENING, d.origH - dy); newTop  = d.origTop  + (d.origH - newH); }

        newLeft = Math.max(MIN_MARGIN, newLeft);
        newTop  = Math.max(MIN_MARGIN, newTop);
        if (newLeft + newW > fmt.w - MIN_MARGIN) newW = fmt.w - MIN_MARGIN - newLeft;
        if (newTop  + newH > fmt.h - MIN_MARGIN) newH = fmt.h - MIN_MARGIN - newTop;

        od.w    = parseFloat(newW.toFixed(1));
        od.h    = parseFloat(newH.toFixed(1));
        od.left = parseFloat(newLeft.toFixed(2));
        od.top  = parseFloat(newTop.toFixed(2));

        // Multi-resize: pas dezelfde schaalfactor toe op alle andere geselecteerde openings
        if (state.selectedOpenings.size > 1 && state.selectedOpenings.has(d.idx)) {
          const scaleW = d.origW > 0 ? newW / d.origW : 1;
          const scaleH = d.origH > 0 ? newH / d.origH : 1;
          state.selectedOpenings.forEach(function (si) {
            if (si === d.idx) return;
            const orig = d.origSizes[si];
            if (!orig) return;
            const sod  = state.openingPositions[si];
            sod.w = parseFloat(Math.max(MIN_OPENING, orig.w * scaleW).toFixed(1));
            sod.h = parseFloat(Math.max(MIN_OPENING, orig.h * scaleH).toFixed(1));
            // Positie ongewijzigd — top-left blijft staan
            const origPos = d.origPositions[si];
            if (origPos) {
              sod.left = parseFloat(Math.max(MIN_MARGIN, origPos.left).toFixed(2));
              sod.top  = parseFloat(Math.max(MIN_MARGIN, origPos.top).toFixed(2));
            }
          });
        }
      }

      // Alleen SVG + info hertekenen tijdens slepen (snel)
      updatePreview();
      updateOpeningInfo();
      updateAddButton();
    }

    function onEnd(e) {
      if (!svgDrag) return;
      const d = svgDrag;
      svgDrag = null;
      snapLines = [];

      if (!d.moved) {
        // Tik/klik: toggle selectie
        const idx = d.idx;
        const coords = getEventCoords(e);
        if (coords.shiftKey) {
          if (state.selectedOpenings.has(idx)) {
            state.selectedOpenings.delete(idx);
          } else {
            state.selectedOpenings.add(idx);
          }
        } else {
          if (state.selectedOpenings.has(idx) && state.selectedOpenings.size === 1) {
            state.selectedOpenings.delete(idx);
          } else {
            state.selectedOpenings = new Set([idx]);
          }
        }
        update();
        return;
      }

      // Drag/swipe voltooid
      syncOpeningSizeInputs();
      renderPositionInputs();
      update();
    }

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onEnd);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onEnd);
  }

  // ----------------------------------------------------------------
  // Foto resize via canvas
  // ----------------------------------------------------------------

  function resizeImage(dataUrl, maxPx, callback) {
    const img = new Image();
    img.onload = function () {
      const scale = Math.min(1, maxPx / img.width, maxPx / img.height);
      const w = Math.round(img.width  * scale);
      const h = Math.round(img.height * scale);
      const canvas = document.createElement('canvas');
      canvas.width  = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      callback(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.src = dataUrl;
  }

  // ----------------------------------------------------------------
  // Event bindings
  // ----------------------------------------------------------------

  function syncOpeningSizeInputs() {
    for (let i = 0; i < state.openings; i++) {
      const od = state.openingPositions[i];
      const wInp = document.getElementById('ppb-size-' + i + '-w');
      const hInp = document.getElementById('ppb-size-' + i + '-h');
      if (wInp) wInp.value = od.w;
      if (hInp) hInp.value = od.h;
    }
  }

  function updateColorCircleTexture() {
    const isLinnen = state.material === 'linnenstof';
    document.querySelectorAll('.ppb-color-circle').forEach(function (el) {
      el.classList.toggle('ppb-color-circle--linnen', isLinnen);
      el.classList.toggle('ppb-color-circle--karton', !isLinnen);
    });
  }

  function updateColorVisibility() {
    const mat = state.material;
    // state.material is 'standaard' or 'linnenstof'; data-material is 'karton' or 'linnenstof'
    const materialKey = mat === 'standaard' ? 'karton' : mat;
    let activeVisible = false;
    document.querySelectorAll('.ppb-color-swatch[data-material]').forEach(function (btn) {
      const visible = btn.dataset.material === materialKey;
      btn.style.display = visible ? '' : 'none';
      if (visible && btn.classList.contains('is-active')) activeVisible = true;
    });
    // Als de geselecteerde kleur niet beschikbaar is, switch naar een standaardkleur
    if (!activeVisible) {
      const fallback = mat === 'linnenstof' ? 'Linnen 1' : 'Canvas Cream';
      state.color = fallback;
      document.querySelectorAll('.ppb-color-swatch').forEach(function (b) {
        const match = b.dataset.colorName === fallback;
        b.classList.toggle('is-active', match);
        b.setAttribute('aria-pressed', match ? 'true' : 'false');
      });
    }
  }

  function resetPositions() {
    for (let i = 0; i < 4; i++) {
      state.openingPositions[i].left = null;
      state.openingPositions[i].top  = null;
    }
  }

  // Verdeelt N openingen gelijkmatig over het canvas.
  // Elke opening krijgt de template-afmeting (openingW/H), aangepast aan het raster.
  // 2 → 2 kolommen naast elkaar, 3 → 3 kolommen, 4 → 2×2 raster.
  function computeAutoLayout() {
    const fmt = getActiveFormat();
    const n = state.openings;

    // Reset posities voor alle slots
    for (let i = 0; i < state.openingPositions.length; i++) {
      state.openingPositions[i].left = null;
      state.openingPositions[i].top  = null;
    }

    if (n <= 1) {
      var maxW1 = Math.max(1, fmt.w - 2 * MIN_MARGIN);
      var maxH1 = Math.max(1, fmt.h - 2 * MIN_MARGIN);
      state.openingPositions[0].w = parseFloat(Math.min(state.openingW, maxW1).toFixed(1));
      state.openingPositions[0].h = parseFloat(Math.min(state.openingH, maxH1).toFixed(1));
      return;
    }

    // Bepaal kolommen: zo vierkant mogelijk
    let cols;
    if (n === 2) { cols = 2; }
    else if (n === 3) { cols = 3; }
    else { cols = Math.ceil(Math.sqrt(n)); }
    const rows = Math.ceil(n / cols);

    const gap  = LAYOUT_GAP;
    const maxW = Math.max(1, (fmt.w - 2 * MIN_MARGIN - (cols - 1) * gap) / cols);
    const maxH = Math.max(1, (fmt.h - 2 * MIN_MARGIN - (rows - 1) * gap) / rows);

    const fitW = Math.floor(Math.min(state.openingW, maxW) * 10) / 10;
    const fitH = Math.floor(Math.min(state.openingH, maxH) * 10) / 10;

    const gridW  = cols * fitW + (cols - 1) * gap;
    const gridH  = rows * fitH + (rows - 1) * gap;
    const startX = Math.max(MIN_MARGIN, (fmt.w - gridW) / 2);
    const startY = Math.max(MIN_MARGIN, (fmt.h - gridH) / 2);

    let idx = 0;
    for (let r = 0; r < rows && idx < n; r++) {
      for (let c = 0; c < cols && idx < n; c++) {
        state.openingPositions[idx].w    = fitW;
        state.openingPositions[idx].h    = fitH;
        state.openingPositions[idx].left = parseFloat((startX + c * (fitW + gap)).toFixed(2));
        state.openingPositions[idx].top  = parseFloat((startY + r * (fitH + gap)).toFixed(2));
        idx++;
      }
    }
  }

  function bindEvents() {
    // Stap 1 — Vaste formaten
    FORMATS.forEach(function (fmt) {
      const btn = document.getElementById('ppb-format-' + fmt.key);
      if (!btn) return;
      btn.addEventListener('click', function () {
        state.format = fmt.key;
        state.customFormat = false;
        document.querySelectorAll('.ppb-format-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        const customInputs = document.getElementById('ppb-custom-format-inputs');
        if (customInputs) customInputs.style.display = 'none';
        const customErr = document.getElementById('ppb-format-error');
        if (customErr) customErr.textContent = '';
        // Clip template + per-opening afmetingen naar nieuw formaat
        const f = getActiveFormat();
        state.openingW = Math.min(state.openingW, f.w - 2 * MIN_MARGIN);
        state.openingH = Math.min(state.openingH, f.h - 2 * MIN_MARGIN);
        for (let i = 0; i < state.openingPositions.length; i++) {
          state.openingPositions[i].w = Math.min(state.openingPositions[i].w, f.w - 2 * MIN_MARGIN);
          state.openingPositions[i].h = Math.min(state.openingPositions[i].h, f.h - 2 * MIN_MARGIN);
        }
        computeAutoLayout();
        syncOpeningSizeInputs();
        renderPositionInputs();
        update();
      });
    });

    // Stap 1 — Eigen formaat knop
    const customBtn = document.getElementById('ppb-format-custom');
    if (customBtn) {
      customBtn.addEventListener('click', function () {
        state.customFormat = true;
        document.querySelectorAll('.ppb-format-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        customBtn.classList.add('is-active');
        customBtn.setAttribute('aria-pressed', 'true');
        const customInputs = document.getElementById('ppb-custom-format-inputs');
        if (customInputs) customInputs.style.display = '';
        computeAutoLayout();
        syncOpeningSizeInputs();
        renderPositionInputs();
        update();
      });
    }

    // Stap 1 — Custom formaat invoer
    const customWInput = document.getElementById('ppb-custom-w');
    const customHInput = document.getElementById('ppb-custom-h');
    if (customWInput) {
      customWInput.addEventListener('input', function () {
        state.customW = parseFloat(customWInput.value) || 21;
        const errEl = document.getElementById('ppb-format-error');
        if (errEl) errEl.textContent = validateFormat()[0] || '';
        computeAutoLayout(); syncOpeningSizeInputs();
        if (state.openings > 1) renderPositionInputs();
        update();
      });
    }
    if (customHInput) {
      customHInput.addEventListener('input', function () {
        state.customH = parseFloat(customHInput.value) || 30;
        const errEl = document.getElementById('ppb-format-error');
        if (errEl) errEl.textContent = validateFormat()[0] || '';
        computeAutoLayout(); syncOpeningSizeInputs();
        if (state.openings > 1) renderPositionInputs();
        update();
      });
    }

    // Stap 2 — Materiaal
    ['standaard', 'linnenstof'].forEach(function (mat) {
      var btn = document.getElementById('ppb-material-' + mat);
      if (!btn) return;
      btn.addEventListener('click', function () {
        state.material = mat;
        document.querySelectorAll('.ppb-material-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        updateColorCircleTexture();
        updateColorVisibility();
        update();
      });
    });

    // Stap 3 — Kleuren
    document.querySelectorAll('.ppb-color-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.color = btn.dataset.colorName;
        document.querySelectorAll('.ppb-color-swatch').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        update();
      });
    });

    // Stap 4 — Openingen (aantal)
    function setOpenings(n) {
      state.openings = n;
      state.selectedOpenings = new Set();
      computeAutoLayout();
      syncOpeningSizeInputs();
      document.querySelectorAll('.ppb-opening-btn').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      const fixedBtn = document.getElementById('ppb-openings-' + n);
      if (fixedBtn) {
        fixedBtn.classList.add('is-active');
        fixedBtn.setAttribute('aria-pressed', 'true');
      }
      renderPositionInputs();
      update();
    }

    [1, 2, 3, 4].forEach(function (n) {
      const btn = document.getElementById('ppb-openings-' + n);
      if (!btn) return;
      btn.addEventListener('click', function () {
        const customInput = document.getElementById('ppb-openings-custom');
        if (customInput) customInput.value = '';
        setOpenings(n);
      });
    });

    const customOpeningInput = document.getElementById('ppb-openings-custom');
    if (customOpeningInput) {
      customOpeningInput.addEventListener('input', function () {
        const val = parseInt(this.value, 10);
        if (!val || val < 1 || val > 20) return;
        document.querySelectorAll('.ppb-opening-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        setOpenings(val);
      });
    }

    // Stap 5 — Foto upload (alleen voor 1 opening; bij meerdere loopt dit via renderPositionInputs)
    const photoInput = document.getElementById('ppb-photo-input');
    if (photoInput) {
      photoInput.addEventListener('change', function () {
        const file = photoInput.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = function (e) {
          resizeImage(e.target.result, 800, function (resized) {
            state.openingPositions[0].photoDataUrl = resized;
            const details   = document.getElementById('ppb-photo-details');
            const filename  = document.getElementById('ppb-photo-filename');
            const removeBtn = document.getElementById('ppb-photo-remove');
            if (details)   details.style.display  = '';
            if (filename)  filename.textContent    = file.name;
            if (removeBtn) removeBtn.style.display = '';
            update();
          });
        };
        reader.readAsDataURL(file);
      });
    }

    const photoWInput = document.getElementById('ppb-photo-w');
    const photoHInput = document.getElementById('ppb-photo-h');
    if (photoWInput) {
      photoWInput.addEventListener('input', function () {
        const val = parseFloat(photoWInput.value);
        state.openingPositions[0].photoW = isNaN(val) ? null : val;
        update();
      });
    }
    if (photoHInput) {
      photoHInput.addEventListener('input', function () {
        const val = parseFloat(photoHInput.value);
        state.openingPositions[0].photoH = isNaN(val) ? null : val;
        update();
      });
    }

    const photoRemoveBtn = document.getElementById('ppb-photo-remove');
    if (photoRemoveBtn) {
      photoRemoveBtn.addEventListener('click', function () {
        state.openingPositions[0].photoDataUrl = null;
        state.openingPositions[0].photoW = null;
        state.openingPositions[0].photoH = null;
        if (photoInput) photoInput.value = '';
        const details = document.getElementById('ppb-photo-details');
        if (details) details.style.display = 'none';
        photoRemoveBtn.style.display = 'none';
        update();
      });
    }

    // Toevoegen aan winkelwagen
    const addBtn = document.getElementById('ppb-add-btn');
    if (addBtn) addBtn.addEventListener('click', addToCart);

    // Alignment-toolbar knoppen
    document.querySelectorAll('.ppb-align-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.dataset.align;
        if (action === 'center-h')    centerInFrame('h');
        else if (action === 'center-v')    centerInFrame('v');
        else if (action === 'center-both') centerInFrame('both');
        else alignOpenings(action);
      });
    });

    function distributeOpenings(axis) {
      const indices = Array.from(state.selectedOpenings);
      if (indices.length < 2) return;
      saveHistory();
      const gapInput = document.getElementById('ppb-distribute-gap');
      const gap = Math.max(0, parseFloat(gapInput ? gapInput.value : 2) || 2);

      if (axis === 'h') {
        // Sorteer op huidige left-positie, eerste blijft staan
        indices.sort(function (a, b) { return getEffectiveLeft(a) - getEffectiveLeft(b); });
        let cursor = getEffectiveLeft(indices[0]);
        state.openingPositions[indices[0]].left = parseFloat(cursor.toFixed(2));
        for (let c = 1; c < indices.length; c++) {
          cursor += state.openingPositions[indices[c - 1]].w + gap;
          state.openingPositions[indices[c]].left = parseFloat(cursor.toFixed(2));
        }
      } else {
        // Sorteer op huidige top-positie, eerste blijft staan
        indices.sort(function (a, b) { return getEffectiveTop(a) - getEffectiveTop(b); });
        let cursor = getEffectiveTop(indices[0]);
        state.openingPositions[indices[0]].top = parseFloat(cursor.toFixed(2));
        for (let r = 1; r < indices.length; r++) {
          cursor += state.openingPositions[indices[r - 1]].h + gap;
          state.openingPositions[indices[r]].top = parseFloat(cursor.toFixed(2));
        }
      }
      renderPositionInputs();
      update();
    }

    const distributeHBtn = document.getElementById('ppb-distribute-h');
    if (distributeHBtn) distributeHBtn.addEventListener('click', function () { distributeOpenings('h'); });
    const distributeVBtn = document.getElementById('ppb-distribute-v');
    if (distributeVBtn) distributeVBtn.addEventListener('click', function () { distributeOpenings('v'); });
    const distributeGapInput = document.getElementById('ppb-distribute-gap');
    if (distributeGapInput) {
      distributeGapInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          distributeOpenings('h');
        }
      });
    }

    const deleteBtn = document.getElementById('ppb-delete-selected');
    if (deleteBtn) {
      deleteBtn.addEventListener('click', function () {
        const toDelete = Array.from(state.selectedOpenings).sort(function (a, b) { return b - a; });
        if (!toDelete.length) return;
        if (state.openings - toDelete.length < 1) return; // minstens 1 opening behouden
        saveHistory();

        // Verwijder van achteren naar voren zodat indices kloppen
        toDelete.forEach(function (idx) {
          state.openingPositions.splice(idx, 1);
        });
        // Vul terug aan tot 20 slots
        while (state.openingPositions.length < 20) {
          state.openingPositions.push({ left: null, top: null, w: state.openingW, h: state.openingH, photoDataUrl: null, photoW: null, photoH: null });
        }
        state.openings -= toDelete.length;
        state.selectedOpenings = new Set();

        // Sync custom input en knoppen
        const customInput = document.getElementById('ppb-openings-custom');
        if (customInput) customInput.value = [1,2,3,4].includes(state.openings) ? '' : state.openings;
        document.querySelectorAll('.ppb-opening-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        const fixedBtn = document.getElementById('ppb-openings-' + state.openings);
        if (fixedBtn) { fixedBtn.classList.add('is-active'); fixedBtn.setAttribute('aria-pressed', 'true'); }

        renderPositionInputs();
        update();
      });
    }
  }

  // ----------------------------------------------------------------
  // Init
  // ----------------------------------------------------------------

  function initColorModal() {
    const openBtn  = document.getElementById('ppb-open-color-modal');
    const closeBtn = document.getElementById('ppb-close-color-modal');
    const modal    = document.getElementById('ppb-color-modal');
    if (!openBtn || !modal) return;

    openBtn.addEventListener('click', function () {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    });

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      openBtn.focus();
    }

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initUndo() {
    const btn = document.getElementById('ppb-undo');
    if (btn) btn.addEventListener('click', undoHistory);

    document.addEventListener('keydown', function (e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'z' && !e.shiftKey) {
        const active = document.activeElement;
        const isInput = active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA');
        if (!isInput) {
          e.preventDefault();
          undoHistory();
        }
      }
    });
  }

  function initCheatsheet() {
    const openBtn  = document.getElementById('ppb-open-cheatsheet');
    const closeBtn = document.getElementById('ppb-close-cheatsheet');
    const modal    = document.getElementById('ppb-cheatsheet-modal');
    if (!openBtn || !modal) return;

    var cheatsheetTargetOpening = null; // null = gebruik selectie/alle

    function openModal(targetOpening) {
      cheatsheetTargetOpening = (targetOpening !== undefined) ? targetOpening : null;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      cheatsheetTargetOpening = null;
    }

    openBtn.addEventListener('click', function () { openModal(); });

    // Knoppen per opening (dynamisch gegenereerd, dus via delegatie)
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.ppb-cheatsheet-btn--inline');
      if (!btn) return;
      const idx = parseInt(btn.dataset.openingTarget, 10);
      openModal(idx);
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

    // "Gebruik" knoppen: vul binnenmaat in voor geselecteerde openingen (of alle als geen geselecteerd)
    modal.querySelectorAll('.ppb-cheatsheet-apply').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const w = parseFloat(btn.dataset.w);
        const h = parseFloat(btn.dataset.h);

        // Welke openingen updaten? Via inline-knop → die specifieke opening; anders geselecteerde of alle
        const targets = cheatsheetTargetOpening !== null
          ? [cheatsheetTargetOpening]
          : state.selectedOpenings.size > 0
            ? Array.from(state.selectedOpenings)
            : Array.from({ length: state.openings }, function (_, i) { return i; });

        targets.forEach(function (idx) {
          state.openingPositions[idx].w = w;
          state.openingPositions[idx].h = h;
          var wInput = document.getElementById('ppb-size-' + idx + '-w');
          var hInput = document.getElementById('ppb-size-' + idx + '-h');
          if (wInput) wInput.value = w;
          if (hInput) hInput.value = h;
        });

        update();
        closeModal();
      });
    });
  }

  function fixSiblingTitles() {
    const builder = document.getElementById('passe-partout-builder');
    if (!builder) return;

    // Vervang gewone koppeltekens in "passe-partout" door niet-afbrekend koppelteken
    document.querySelectorAll('.ppb-section-title, .ppb-section h2, .ppb-section h1').forEach(function(el) {
      el.innerHTML = el.innerHTML.replace(/passe-partout/gi, 'passe‑partout');
    });

    // Verander "Customer Reviews" / "Klantbeoordelingen" naar "Reviews"
    document.querySelectorAll('[class*="jdgm-rev-widg__title"], [class*="jdgm-widget-title"], [class*="jdgm-all-reviews__title"]').forEach(function(el) {
      if (/customer reviews|klantbeoordelingen/i.test(el.textContent)) {
        el.textContent = 'Reviews';
      }
    });

    if (!isEN) return;
    var section = builder.closest('.shopify-section');
    if (!section) return;
    var sibling = section.nextElementSibling;
    while (sibling) {
      sibling.querySelectorAll('h2, .title').forEach(function(el) {
        if (el.textContent.trim().toLowerCase().includes('suitable list')) {
          el.textContent = el.textContent.replace(/suitable list/i, 'suitable frame');
        }
      });
      sibling = sibling.nextElementSibling;
    }
  }

  function init() {
    const root = document.getElementById('passe-partout-builder');
    if (!root) return;

    initSVGDragListeners();
    bindEvents();
    updateColorCircleTexture();
    updateColorVisibility();
    renderPositionInputs();
    update();
    initColorModal();
    initCheatsheet();
    initUndo();
    fixSiblingTitles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
